/**
 * TocLink Class
 */
export class TocLink {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * clickedHandler
	 *
	 * @param {object} e
	 */
	clickedHandler = ( e ) => {

		e.preventDefault();

		const level = e.target.dataset.level;
		const headingSelector = `h${level}`;
		const headingElement = [...document.querySelectorAll( headingSelector )].filter( a => a.textContent.includes( e.target.textContent ) )
		if( headingElement.length >0 ){

			headingElement[0].scrollIntoView( {
				behavior: 'smooth',
			} );

		}

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				const nodes = block.querySelectorAll( ( 'a' ) );
				nodes.forEach( ( item ) => {

					item.addEventListener( 'click', this.clickedHandler )

				} )

			} );

		}

	}

}
